export const ZoneConfig = [{
    type: 'live',
    name: '正在直播',
    navName: '直播',
    tid: 'live',
    morelink: '//live.bilibili.com/',
    component: 'Live'
  },
  {
    type: 'douga',
    name: '动画',
    zid: 1554,
    tid: 1,
    morelink: '/v/douga',
    component: 'Zone'
  },
  {
    type: 'anime',
    name: '番剧',
    alias: '番剧',
    zid: 1556,
    tid: 13,
    morelink: '//www.bilibili.com/anime/',
    component: 'Anime',
  },
  {
    type: 'guochuang',
    name: '国创',
    alias: '国产动画',
    zid: 1919,
    tid: 168,
    morelink: '//www.bilibili.com/guochuang/',
    component: 'Guochuang',
  },
  {
    type: 'manga',
    name: '漫画',
    alias: '漫画',
    // zid: 1919,
    // tid: 168,
    morelink: '//manga.bilibili.com/',
    component: 'Manga',
  },
  {
    type: 'music',
    name: '音乐',
    zid: 1558,
    tid: 3,
    morelink: '/v/music',
    component: 'Zone',
  },
  {
    type: 'dance',
    name: '舞蹈',
    zid: 1560,
    tid: 129,
    morelink: '/v/dance',
    component: 'Zone',
  },
  {
    type: 'game',
    name: '游戏',
    zid: 1562,
    tid: 4,
    morelink: '/v/game',
    component: 'Zone',
  },
  {
    type: 'technology',
    name: '知识',
    zid: 1624,
    tid: 36,
    morelink: '/v/technology',
    component: 'Zone',
  },
  {
    type: 'cheese',
    name: '课堂',
    morelink: '/cheese',
    component: 'Cheese',
  },
  {
    type: 'digital',
    name: '数码',
    tid: 188,
    morelink: '/v/digital',
    component: 'Zone',
  },
  {
    type: 'life',
    name: '生活',
    zid: 1564,
    tid: 160,
    morelink: '/v/life',
    component: 'Zone',
  },
  {
    type: 'food',
    name: '美食',
    zid: 2273,
    tid: 211,
    morelink: '/v/food',
    component: 'Zone'
  },
  {
    type: 'animal',
    name: '动物圈',
    tid: 217,
    morelink: '/v/animal',
    component: 'Zone'
  },
  {
    type: 'kichiku',
    name: '鬼畜',
    zid: 1566,
    tid: 119,
    morelink: '/v/kichiku',
    component: 'Zone',
  },
  {
    type: 'fashion',
    name: '时尚',
    zid: 1568,
    tid: 155,
    morelink: '/v/fashion',
    component: 'Zone',
  },
  {
    type: 'information',
    name: '资讯',
    tid: 202,
    morelink: '/v/information',
    component: 'ZoneInformation',
  },
  {
    type: 'ent',
    name: '娱乐',
    zid: 1570,
    tid: 5,
    morelink: '/v/ent',
    component: 'Zone',
  },
  {
    type: 'read',
    name: '专栏',
    morelink: '//www.bilibili.com/read/home',
    component: 'Article',
  },
  {
    type: 'movie',
    name: '电影',
    zid: 1572,
    tid: 23,
    morelink: '/movie',
    component: 'Zone',
  },
  {
    type: 'teleplay',
    name: '电视剧',
    navName: 'TV剧',
    zid: 1574,
    tid: 11,
    morelink: '/tv',
    component: 'Zone',
  },
  {
    type: 'cinephile',
    name: '影视',
    zid: 2207,
    tid: 181,
    morelink: '/v/cinephile',
    component: 'Zone',
  },
  {
    type: 'documentary',
    name: '纪录片',
    zid: 2257,
    tid: 177,
    morelink: '/documentary',
    component: 'Zone',
  }
]

//楼层广告配置
export const FloorAdConfig = [{
    pos: 0,
    dataLocId: 40
  },
  {
    pos: 2,
    dataLocId: 42
  },
  {
    pos: 4,
    dataLocId: 44
  }
]